"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Icon_1 = __importDefault(require("semantic-ui-react/dist/commonjs/elements/Icon/Icon"));
var Media_1 = require("../Media");
var Button_1 = require("../Button/Button");
require("./BackToTopButton.css");
var MIN_HEIGHT_SCROLL_BACK = 500;
var DEFAULT_SCROLL_TO_OPTS = { top: 0, behavior: 'smooth' };
var BackToTopButton = function (_a) {
    var className = _a.className, _b = _a.threshold, threshold = _b === void 0 ? MIN_HEIGHT_SCROLL_BACK : _b, _c = _a.scrollToOptions, scrollToOptions = _c === void 0 ? DEFAULT_SCROLL_TO_OPTS : _c, i18n = _a.i18n;
    var _d = (i18n || {}).title, title = _d === void 0 ? 'Back to top' : _d;
    var isDesktop = (0, Media_1.useNotMobileMediaQuery)();
    var _e = (0, react_1.useState)(false), showButton = _e[0], setShowButton = _e[1];
    (0, react_1.useEffect)(function () {
        var scrollListener = function () {
            setShowButton(window.scrollY > threshold);
        };
        window.addEventListener('scroll', scrollListener);
        return function () { return window.removeEventListener('scroll', scrollListener); };
    }, [threshold]);
    var handleBackToTop = (0, react_1.useCallback)(function () {
        window.scrollTo(scrollToOptions);
    }, [scrollToOptions]);
    return showButton ? (react_1.default.createElement(Button_1.Button, { className: (0, classnames_1.default)(className, 'backToTop'), onClick: handleBackToTop },
        react_1.default.createElement(Icon_1.default, { name: "arrow up" }),
        isDesktop ? title : null)) : null;
};
exports.default = react_1.default.memo(BackToTopButton);
